import {
  Component,
  ComponentFactoryResolver,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { applications } from 'src/app/shared/utils';
import { SwitchAppService } from 'src/app/switch-app.service';
import { AppType } from 'src/environments/environmentTypes';

@Component({
  selector: 'app-unblock',
  templateUrl: './unblock.component.html',
  styleUrls: ['./unblock.component.css'],
})
export class UnblockComponent implements OnInit {
  applications: {
    clientId: string;
    domain: string;
    logo: string;
    title: string;
    pageTitle: string;
    type: AppType;
  }[];
  clientId: string;
  constructor(
    activatedRoute: ActivatedRoute,
    title: Title,
    private resolve: ComponentFactoryResolver,
    public viewContainerRef: ViewContainerRef,
    private switchApp: SwitchAppService
  ) {
    this.applications = applications();

    activatedRoute.params.subscribe((param) => {
      this.clientId = param['client_id'];
    });

    title.setTitle('ロックを解除しました');
    const app = this.applications.find((e) => e.clientId === this.clientId);
    if (app) {
      this.switchApp.setComponent(
        this.clientId,
        app.type,
        viewContainerRef,
        resolve,
        'unblock'
      );
    }
  }

  get isStation(): boolean {
    return /dstation/g.test(
      this.applications.find((app) => app.clientId === this.clientId).type
    );
  }

  ngOnInit(): void {}
}
